import React, { useContext, useState, ChangeEvent } from 'react';
import {
  ProfileContext,
  ProfileContextProps,
} from '../../../context/ProfileContext';
import AnklePatrolLogo from '../../../assets/AnklePatrol_Logo_white.png';
import SearchIcondef from '../../../assets/Search 2.svg';
import './BabysitterDashboardHeader.css';
import { useNavigate } from 'react-router-dom';
import messageIcon from '../../../assets/Message 28.svg';
import NotificationIcon from '../../../assets/Notification 1.svg';
import NotificationwhiteIcon from '../../../assets/NotoficationIcon.svg';
import { Box, Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { IconButton, InputAdornment, Modal } from '@mui/material';
import { AppBar, Toolbar, Grid } from '@mui/material';
import { Notifications, Chat } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { searchConsumers } from '../../../services/NetworkServices';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  BabysitterContext,
  BabysitterContextProps,
} from '../../../context/BabysitterContext';
import { useEffect } from 'react';
import { useWebSocket } from '../../../context/WebSocketContext';

const BabysitterDashboardHeader: React.FC = () => {
  const { userProfile } = useContext(ProfileContext) as ProfileContextProps;
  const {
    markAsRead,
    notificationsList,
    notificationsCount,
    handleNotificationsCount,
    handleNotificationsList,
  } = useContext(BabysitterContext) as BabysitterContextProps;
  const { socket } = useWebSocket();
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showNotificationListPopup, setShowNotificationListPopup] =
    useState<boolean>(false);

  const formatNotification = (data: any): any => {
    return {
      createdAt: new Date().toISOString(),
      message: data.message,
      notificationType: data.notificationType || data.type, // Ensure correct key for type
      read: false,
      updatedAt: new Date().toISOString(),
      userFrom: data.userFrom || null,
      userTo: data.userTo || null,
      _id: data._id || generateUniqueId(), // Generate a unique ID if not provided
    };
  };

  // Utility function to generate a unique ID if none is provided
  const generateUniqueId = () => {
    return '_' + Math.random().toString(36).substr(2, 9);
  };

  const onChangeSearchInput = async (event: ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
    const response = await searchConsumers({ search: event.target.value });
    const data = await response.data;
    console.log(response);

    if (data) {
      setSearchResults(data.data.consumerProfiles);
    }
  };

  //  const filteredConsumersListByDate = consumersWithId.map(
  //    (consumer: Consumer) => ({
  //      date: consumer._id,
  //      users: consumer.users,
  //    })
  //  );

  //  setConsumersList(filteredConsumersListByDate);

  useEffect(() => {
    socket?.on('bell-badge-notification', (data) => {
      console.log(data);
      handleNotificationsCount(data.count);
    });
  }, [socket, notificationsCount, markAsRead]);

  useEffect(() => {
    const handleNotification = (data: any) => {
      console.log('notification received', data);

      const todayDate = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format

      const newNotification = formatNotification(data); // Format the notification

      // Create a copy of the current list
      const updatedList = [...notificationsList]; // You might need to replace this with how you are managing the list

      // Find if today's date already exists in the list
      const existingDateIndex = updatedList.findIndex(
        (item) => item.date === todayDate,
      );

      if (existingDateIndex !== -1) {
        // If today's date exists, unshift the new notification to the start of the notifications array
        updatedList[existingDateIndex].notifications.unshift(newNotification);
      } else {
        // If today's date doesn't exist, create a new entry at the beginning
        updatedList.unshift({
          date: todayDate,
          notifications: [newNotification],
        });
      }

      // Pass the updated list to handleNotificationsList
      handleNotificationsList(updatedList);
    };

    socket?.on('group-message-notification', handleNotification);
    socket?.on('face-auth-success-notification', handleNotification);
    socket?.on('face-auth-fail-notification', handleNotification);
    socket?.on('broadcast-notification', handleNotification);

    // Cleanup socket listeners on unmount
    return () => {
      socket?.off('group-message-notification', handleNotification);
      socket?.off('face-auth-success-notification', handleNotification);
      socket?.off('face-auth-fail-notification', handleNotification);
      socket?.off('broadcast-notification', handleNotification);
    };
  }, [socket, notificationsList]);

  const handleNotificationList = async () => {
    setShowNotificationListPopup(true);
  };

  return (
    <Grid
      container
      alignItems="center"
      spacing={2}
      sx={{ padding: '20px 0', display: 'flex', justifyContent: 'center' }}
    >
      <Grid item xs={12} md={3} display="flex" alignItems="center">
        <Box display="flex" alignItems="center">
          <img
            src={AnklePatrolLogo}
            alt="AP Logo"
            style={{ width: '80px', height: '60px' }}
          />
          {searchInput !== '' && (
            <Typography>{searchResults.length} Participants</Typography>
          )}
        </Box>
      </Grid>
      {/* Center Section: Search Bar */}

      <Grid
        item
        xs={12}
        md={6}
        sx={{ display: 'flex', justifyContent: { xs: 'start', md: 'center' } }}
      >
        <Box
          sx={{
            borderColor: '#365F91',
            border: '1.4px solid transparent',
            background: `
                  linear-gradient(black, black) padding-box,
                  linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
                `,
            borderImageSlice: 1,
            borderRadius: '33px',
            width: '100%',
            height: '50px',
            maxWidth: '600px',
            padding: '0px 2px',
            alignItems: 'center',
            position: 'relative', // Important to position suggestion box relative to the search bar
          }}
        >
          <TextField
            placeholder="Search Participants"
            InputLabelProps={{
              style: { color: 'green', width: '100%' }, // Label color
            }}
            value={searchInput}
            onChange={onChangeSearchInput}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ padding: '0px' }}>
                  <IconButton sx={{ padding: '0px' }}>
                    <img
                      src={SearchIcondef}
                      style={{ width: '25px', height: '25px' }}
                    />
                  </IconButton>
                </InputAdornment>
              ),
              endAdornment: searchInput && (
                <InputAdornment position="end">
                  <IconButton onClick={() => setSearchInput('')}>
                    <CancelIcon sx={{ color: 'white' }} />
                  </IconButton>
                </InputAdornment>
              ),
              style: { color: 'white' }, // Text color
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'transparent', // Hide the border
                },
                '&:hover fieldset': {
                  borderColor: 'transparent', // Hide the border on hover
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'transparent', // Prevent border color change on focus
                },
              },
              '&:focus-visible': {
                outline: 'none', // Remove the default blue outline
              },
              '&.Mui-focused': {
                outline: 'none', // Remove focus outline
              },
            }}
          />

          {/* Auto-suggestion Box */}
          {searchInput && searchResults.length > 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: '60px', // Positioned right below the search bar
                width: '100%',
                maxHeight: '300px', // Limits height if there are many results
                overflowY: 'auto', // Makes the suggestion list scrollable

                borderRadius: '33px',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                zIndex: 1000, // Ensures the dropdown is above other elements
                borderColor: '#365F91',
                border: '1.4px solid transparent',
                background: `
                    linear-gradient(#2C2F33, #2C2F33) padding-box,
                    linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box
                    `,
                borderImageSlice: 1,
              }}
            >
              {searchResults.map((result, index) => (
                <Box
                  key={result.userId}
                  sx={{
                    padding: '10px 15px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    '&:hover': {
                      backgroundColor: '#3C4251', // Hover effect
                    },
                  }}
                  onClick={() =>
                    navigate(`/supervisor/participantDetails/${result.userId}`)
                  }
                >
                  <p style={{ margin: 0, color: 'white' }}>
                    {result.firstName} {result.lastName}
                  </p>
                  <OpenInNewIcon fontSize="small" sx={{ color: '#BCBCBC' }} />
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Grid>

      {/* Right Section: Icons */}
      <Grid
        item
        xs={12}
        md={3}
        display="flex"
        gap={1.5}
        sx={{ justifyContent: { xs: 'start', md: 'flex-end' } }}
      >
        <Box className="HeaderIcons">
          <img
            src={messageIcon}
            onClick={() => navigate('/supervisor/group-chat')}
            style={{ width: '20px' }}
          />
        </Box>

        <Box
          className="HeaderIcons"
          sx={{
            backgroundColor: '#FB5012',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            cursor: 'pointer',
          }}
          onClick={handleNotificationList}
        >
          <img src={NotificationIcon} style={{ width: '20px' }} />
          {notificationsCount > 0 && (
            <Box
              sx={{
                position: 'absolute',
                top: -10,
                right: -10,
                backgroundColor: '#365f91',
                borderRadius: '50%',
                padding: '2px 6px',
                fontSize: '2px !important',
                color: '#fff',
              }}
            >
              <Typography>{notificationsCount}</Typography>
            </Box>
          )}
        </Box>

        {notificationsList.length >= 0 && (
          <Modal
            open={showNotificationListPopup}
            onClose={() => setShowNotificationListPopup(false)}
            sx={{
              position: 'absolute',
              top: { xs: '115px', md: '115px' }, // Same top positioning for both xs and md
              left: { xs: '10px', md: 'auto', lg: '600px' }, // Apply left padding for xs to avoid fixed space
              right: { xs: '10px', md: '40px', lg: '70px' }, // Ensure modal doesn't overflow on xs
              transform: { xs: 'none', md: 'none' }, // No transformation needed
              width: { xs: 'calc(100% - 20px)', md: 'auto' }, // Full width minus padding for xs, auto for md
              maxWidth: { md: 'auto' }, // Prevent max width overflow on larger screens
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                backdropFilter: 'blur(21px)', // Blur effect
                background: '#FFFFFF1A',
                borderTop: '1px solid #365F91',
                borderLeft: '1px solid #365F91',
                borderRight: '1px solid #365F91', // Transparent border for gradient effect
                borderRadius: '24px', // Rounded corners
                padding: '20px', // Padding inside the box
                outline: 'none', // No outline on focus
                width: '100%', // Full width inside the box
              }}
            >
              {notificationsList.length > 0 ? (
                <>
                  {notificationsList
                    .flatMap((notification) => notification.notifications) // Flatten the array
                    .slice(0, 4) // Limit to the first 4 notifications
                    .map((eachNotification: any, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          color: 'white',
                          gap: '10px',
                        }}
                      >
                        <img
                          src={NotificationwhiteIcon}
                          alt="Notification Icon"
                          style={{ width: '30px', height: '30px' }}
                        />
                        <p>{eachNotification?.message}</p>
                      </Box>
                    ))}
                  <a
                    href="/supervisor/notifications"
                    style={{ color: 'white' }}
                  >
                    View All
                  </a>
                </>
              ) : (
                <div style={{ color: 'white', textAlign: 'center' }}>
                  No data found
                </div>
              )}
            </Box>
          </Modal>
        )}

        <img
          src={
            userProfile.profilePic
              ? userProfile.profilePic
              : 'https://www.pngitem.com/pimgs/m/146-1468479_my-profile-icon-blank-profile-picture-circle-hd.png'
          }
          className="profile-pic"
          alt="Profile"
          onClick={() => navigate('/supervisor/edit-profile')}
          style={{ width: '40px', height: '40px', borderRadius: '50%' }}
        />
      </Grid>
    </Grid>
  );
};

export default BabysitterDashboardHeader;
